
<div class="row mb-2">
  <div  class="col-12 d-flex">
    <h3  class="cal-title-ctm title me-auto ng-star-inserted" >Add Prefix Suffix</h3>
    <img src="./assets/images/crossblack.svg" alt="close model" width="24px" height="24px" class="cross-icon module-screen-icon pointer-cls mt-1" (click)="closeDialog()">
  </div>
</div>
<div class="template-modal" (click)="$event.stopPropagation()">
  <form [formGroup]="templateForm">
    <div class="w-100 my-2">
      <span class="label-cls">Prefix</span>
      <input type="text" formControlName="prefix" placeholder="Prefix text" class="my-2 input-cls" trim="blur" max="30"/>
      
      <mat-error *ngIf="templateForm.get('prefix')?.hasError('maxlength') && templateForm.get('prefix')?.touched">
        Prefix text must be at most 25 characters
      </mat-error>
      <span class="label-cls">Suffix</span>
      <input type="text" formControlName="suffix" placeholder="Suffix text" class="my-2 input-cls" trim="blur" max="30"/>
      <mat-error *ngIf="templateForm.get('suffix')?.hasError('maxlength') && templateForm.get('suffix')?.touched">
        Suffix text must be at most 25 characters
      </mat-error>
    </div>

    <div class="d-flex justify-content-end">
      <button  class="btn-cus-cls anchor-link me-2" type="button" (click)="closeDialog()">Skip</button>
      <button  class="btn-cus-cls anchor-link"  type="button" (click)="closeDialog(true)" [disabled]="!templateForm.valid" [ngClass]="!templateForm.valid ? 'disable-cls':''">Done</button>
    </div>
  </form>
</div>